import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';

import classNames from 'classnames';

import type { TransitionSpeed } from '../../../../../../styles/exports/effects';
import { TRANSITION_SPEEDS_MS } from '../../../../../../styles/exports/effects';
import styles from './Transition.module.scss';

type TransitionMode = 'fade';

interface TransitionProps {
  in: boolean;
  children?: ReactNode;
  mode?: TransitionMode;
  speed?: TransitionSpeed;
  onCompleted?: () => unknown;
  nodeRef?: ComponentProps<typeof CSSTransition>['nodeRef'];
}

const Transition = ({
  in: _in,
  children,
  mode = 'fade',
  speed = 'medium',
  onCompleted,
  nodeRef,
}: PropsWithChildren<TransitionProps>) => {
  return (
    <CSSTransition
      in={_in}
      timeout={Number.parseInt(TRANSITION_SPEEDS_MS[speed])}
      onExited={onCompleted}
      nodeRef={nodeRef}
      appear={true}
      mountOnEnter
      unmountOnExit
      classNames={{
        appear: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-appear`]),
        appearActive: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-appear-active`]),
        appearDone: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-appear-done`]),
        enter: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-enter`]),
        enterActive: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-enter-active`]),
        enterDone: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-enter-done`]),
        exit: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-exit`]),
        exitActive: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-exit-active`]),
        exitDone: classNames(styles[`transition__${mode}`], styles[`transition-${speed}`], styles[`transition__${mode}-exit-done`]),
      }}
    >
      {children}
    </CSSTransition>
  );
};

export { Transition };
